import { FilterableTableInvoices } from "../../../components/TableInvoices/FilterableTableInvoices";
import { INVOICE_STATUSES_IN_PROGRESS } from "../../../types";

export const RouteInProgress: React.FC = () => (
  <FilterableTableInvoices
    statuses={INVOICE_STATUSES_IN_PROGRESS}
    showDownloadCsv
    emptyState={{ standart: "No in-progress invoices." }}
  />
);
